class DocumentPartager {
  init () {
    const docPartage = $('.document-partage')
    const docPartageItem = $('.document-partage .document-partage-item')

    if (docPartageItem.length === 0) {
      docPartage.hide()
    } else {
      docPartage.show()
    }
  }
}

export default DocumentPartager
